<div class="pt-24 pb-16" fxLayout="row" fxLayoutAlign="center center" *ngIf="traducciones.length == 0">
    <mat-icon class="m-0 mr-16 secondary-text">error_outline</mat-icon>
    <div class="h2 secondary-text">{{'CERTIFICAR.ADICIONALES.TRADUCCIONES.TITULOALTERNO' | translate}}</div>
</div>
<mat-horizontal-stepper>

    <mat-step *ngFor="let traduccion of traducciones; index as i;" label="{{'NOMBREIDIOMAS.'+traduccion.nombreIdioma|translate}}" state="idioma" errorMessage="{{'CERTIFICAR.ADICIONALES.TRADUCCIONES.NOTYET' | translate}}">

        <form fxLayout="column" fxLayoutAlign="space-between stretch">

            <table *ngFor="let pregunta of traduccion.abiertas; index as idxPreg;" fxLayout="column" fxLayoutAlign="space-between stretch" class="mat-card mat-elevation-z4 p-24 mt-12 mb-12">

                <tr fxLayout="row">
                    <th fxFlex="50" class="accent-500 p-20">{{'CERTIFICAR.ADICIONALES.TRADUCCIONES.MAIN' | translate}}</th>
                    <th fxFlex="50" class="accent-100 p-20">{{'NOMBREIDIOMAS.'+traduccion.nombreIdioma|translate}}</th>
                </tr>
                <!---texto de la practice-->
                <tr fxLayout="row" fxLayoutAlign="space-between stretch">

                    <td fxFlex="50" fxLayout="column" fxLayoutAlign="stretch" class="p-20">

                        <h3><code>{{ pregunta.preguntaNativa }}</code></h3>
                    </td>

                    <td fxFlex="50" fxLayout="column" fxLayoutAlign="stretch">

                        <mat-form-field appearance="outline">
                            <mat-label>{{'CERTIFICAR.FORALL.PRACTICE_TRANSLATE_ABIERTAS' | translate}}</mat-label>
                            <textarea matInput required [value]="pregunta.preguntaTraduccion" (blur)="saveQuestionTranslate($event,pregunta.abiertaId,traduccion.idiomaId);" [disabled]="pasoCompleto || instituto == 'MX' && pregunta.preguntaTraduccion.length > 1"></textarea>
                            <mat-error>{{'CERTIFICAR.ADICIONALES.TRADUCCIONES.INPUT.ERROR' | translate}}</mat-error>
                        </mat-form-field>

                    </td>
                </tr>


                <tr fxLayout="row" fxLayoutAlign="end none">
                    <th colspan="2">{{'CERTIFICAR.ADICIONALES.TRADUCCIONES.COMPLETE' | translate}}
                        <mat-icon>check_circle_outline</mat-icon>
                    </th>
                </tr>

            </table>

            <!-- <p>Put down your phones.</p>
   <input matInput placeholder="Last name, First name" formControlName="control1" required>
   <input matInput placeholder="Last name, First name" formControlName="control2" required>
   <input matInput placeholder="Last name, First name" formControlName="control3" required>
   <input matInput placeholder="Last name, First name" formControlName="control4" required>
   <input matInput placeholder="Last name, First name" formControlName="control5" required> -->
        </form>

    </mat-step>


    <!-- Icon overrides. -->
    <ng-template matStepperIcon="idioma">
        <mat-icon>language</mat-icon>
    </ng-template>
</mat-horizontal-stepper>
